import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout';
import TransformHero from './TransformHero';
import GetInTouchSection from '../../components/shared/GetInTouchSection';
import CustomerQuoteSection from '../../components/shared/CustomerQuoteSection';
import AchieveProfitabilitySection from './AchieveProfitabilitySection';
import TransformPlanFeatures from './TransformPlanFeatures';
import WhyTransform from './WhyTransform';

const TransformPlan = () => (
  <Layout
    isNavInitiallyWhite
    title="Transform Membership Plan | Contractors"
    description="New features in HOVER's Transform membership plan can help power your home improvement business from sales to production. Learn more."
  >
    <TransformHero />
    <AchieveProfitabilitySection />
    <TransformPlanFeatures />
    <WhyTransform />
    <CustomerQuoteSection
      title="Customer Spotlight"
      image={
        <StaticImage
          style={{ borderRadius: '100%', minWidth: 100 }}
          src="../../images/greg-swartz-94581ed5.jpeg"
          alt="Greg Swartz picture"
        />
      }
      quote="With HOVER, we know that when we sell a job, we have an accurate take off for it. All we have to do is a quick verification to send it to the distributor. Where it used to take me 20-35 minutes to build out a material order, it now takes me less than 2 seconds."
      authorDescription="Greg Swartz , CFO, Dabella"
    />

    <GetInTouchSection
      buttonText="Schedule a Demo"
      ctaLink="https://calendly.com/hover-sdr/hover-transform"
    />
  </Layout>
);

export default TransformPlan;
